/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Plan_RepsInputs */

const en_platform_plan_reps = /** @type {(inputs: Platform_Plan_RepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reps`)
};

const pl_platform_plan_reps = /** @type {(inputs: Platform_Plan_RepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Powt.`)
};

/**
* | output |
* | --- |
* | "Reps" |
*
* @param {Platform_Plan_RepsInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_plan_reps = /** @type {((inputs?: Platform_Plan_RepsInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Plan_RepsInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_plan_reps(inputs)
	return en_platform_plan_reps(inputs)
});